import React from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
            }}
        >
            <GridToolbarQuickFilter />
        </Box>
    );
}
export default function Basic(props) {
    let userAttributes = [];
    let i = 0;
    let columns = [];
    let rows = [];

    if (
        props.keysAndVenueUnitPoliciesArray !== undefined
        // &&
        // props.venueListUtilization !== undefined
    ) {
        for (const key of Object.keys(props.keysAndVenueUnitPoliciesArray)) {
            //  if (
            //   props.venueListUtilization[props.venueList[key]["VenueID"]] !==
            //   undefined
            // ) {
            if (props.keysAndVenueUnitPoliciesArray !== undefined) {
                userAttributes.push({
                    id: key,
                    profileName:
                        props.keysAndVenueUnitPoliciesArray[key]["Profile"],
                    networkName:
                        props.keysAndVenueUnitPoliciesArray[key]["SSID"],
                    venueName:
                        props.keysAndVenueUnitPoliciesArray[key]["VenueName"],
                    unitName:
                        props.keysAndVenueUnitPoliciesArray[key]["UnitID"],
                    buildingName:
                        props.keysAndVenueUnitPoliciesArray[key][
                            "UnitBuilding"
                        ],
                    floorName:
                        props.keysAndVenueUnitPoliciesArray[key]["UnitFloor"],
                    psk: props.keysAndVenueUnitPoliciesArray[key]["PSK"],
                    keyID: props.keysAndVenueUnitPoliciesArray[key]["keyID"]
                });
                i = i + 1;
            }
        }
    }
    columns = [
        {
            headerName: "Venue",
            field: "venueName",
            flex: 0.2,
            minWidth: 200,
        },
        {
            headerName: "Unit",
            field: "unitName",
            // minWidth: 120,
            flex: 0.2,
            renderCell: (params) => (
                <div>
                    <div>Unit: {params.row.unitName}</div>
                    <div>Building: {params.row.buildingName}</div>
                    <div>Floor: {params.row.floorName}</div>
                </div>
            ),
        },
        {
            headerName: "Profile",
            field: "profileName",
            // minWidth: 120,
            flex: 0.2,
        },
        {
            headerName: "Network",
            field: "networkName",
            // minWidth: 120,
            flex: 0.2,
        },

        {
            headerName: "PSK",
            field: "psk",
            // minWidth: 120,
            flex: 0.2,
        },
        {
            headerName: "Action",
            field: "action",
            minWidth: 160,
            renderCell: (params) => {
                return (
                    <>
                        <Button
                            onClick={(e) =>
                                props.editPasswordFromTable(
                                  params.row.keyID,
                                  params.row.profileName,
                                  params.row.networkName,
                                  params.row.psk,
                                  params.row.id
                                )
                            }
                            // onClick={(e) => (console.log(params["id"]))}
                            variant="contained"
                            className="expirationAction"
                        >
                            Edit Password
                        </Button>
                    </>
                );
            },
        },
    ];
    rows = userAttributes;
    return (
        <div style={{ height: 400, width: "100%" }}>
            <DataGrid
                rows={rows}
                columns={columns}
                hideFooterPagination={false}
                hideFooter={false}
                getRowHeight={({ id, densityFactor }) => {
                    return 60 * densityFactor;
                }}
                slots={{ toolbar: QuickSearchToolbar }}
                disableRowSelectionOnClick={true}
                initialState={{
                  sorting: {
                      sortModel: [{ field: "profileName", sort: "asc" }],
                  },
                }}
            />
        </div>
    );
}
